var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "dropdown",
      staticClass: "rb-select-wrapper rb-custom-select",
      class: {
        "rb-validrow": _vm.isValidRow,
        "rb-invalidrow": _vm.isInValidRow,
      },
      attrs: { id: _vm.id },
    },
    [
      _c("span", { staticClass: "rb-select--arrows", attrs: { for: _vm.id } }),
      _vm._v(" "),
      _c("input", {
        ref: "inputField",
        attrs: {
          id: _vm.inputId,
          name: _vm.name,
          placeholder: _vm.placeholder,
          autocomplete: "off",
          role: "combobox",
          inputmode: "none",
        },
        on: { click: _vm.onInputClick },
      }),
      _vm._v(" "),
      _vm.dropdownIsVisible
        ? _c(
            "ul",
            { staticClass: "rb-custom-select__ul", style: _vm.adjustedStyle },
            [
              _c(
                "div",
                { staticClass: "rb-custom-select__label-option--placeholder" },
                [_vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.options, function (element, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "rb-custom-select__label-option",
                    attrs: { value: element, role: "listbox" },
                    on: {
                      click: function ($event) {
                        return _vm.onElementClick(element)
                      },
                    },
                  },
                  [_vm._v("\n      " + _vm._s(element) + "\n    ")]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }